import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { Info } from '@mui/icons-material';
import './DescriptionTooltip.css';

const DescriptionTooltip = ({ description }) => {
  if (!description) {
    return null;
  }

  return (
    <Tooltip
      title={
        <div className="description-tooltip-content">

          <div className="description-tooltip-text">
            {description}
          </div>
        </div>
      }
      arrow
      placement="top"
      enterDelay={300}
      leaveDelay={200}
      classes={{
        tooltip: 'description-tooltip',
        arrow: 'description-tooltip-arrow'
      }}
    >
      <IconButton 
        size="small" 
        className="description-info-button"
        sx={{ 
          color: '#AFAFAF',
          '&:hover': {
            color: '#ffffff',
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        }}
      >
        <Info fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default DescriptionTooltip;